import { Component } from '@angular/core';
import { MAPSPersonEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'People') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-mapsperson-form',
    templateUrl: './mapsperson.form.component.html'
})
export class MAPSPersonFormComponent extends BaseFormComponent {
    public record!: MAPSPersonEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'conferenceRegistrations', sectionName: 'Conference Registrations', isExpanded: false },
            { sectionKey: 'personVolunteerActivities', sectionName: 'Person Volunteer Activities', isExpanded: false },
            { sectionKey: 'personHonorReceiveds', sectionName: 'Person Honor Receiveds', isExpanded: false },
            { sectionKey: 'personJobs', sectionName: 'Person Jobs', isExpanded: false },
            { sectionKey: 'profileMatches', sectionName: 'Profile Matches', isExpanded: false }
        ]);
    }
}

